'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REAGAN_MAJOR_VERSION = exports.REAGAN_MAJOR_VERSION = 7;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.39/js/constants.js
// module id = 1289
// module chunks = 3